"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RESOURCE_DT_TARGET_REGISTRY = void 0;
exports.isResourceDtTarget = isResourceDtTarget;
exports.assertResourceDtTargets = assertResourceDtTargets;
exports.getResourceDtTargetDefinition = getResourceDtTargetDefinition;
exports.getResourceDtTargetConfigType = getResourceDtTargetConfigType;
exports.getResourceDtTargetOutputSchema = getResourceDtTargetOutputSchema;
const catalog_1 = require("./catalog");
const resource_dt_target_schemas_1 = require("./resource-dt-target-schemas");
const defaultContext = {
    defaultSources: ['resource', 'revision', 'referentials', 'activities', 'cv'],
    optionalSources: ['documents', 'activity-period', 'need'],
    needRole: 'orientation-only',
};
const targetDefinitions = {
    title: {
        field: 'title',
        public: true,
        label: 'Titre',
        configType: 'enrich-dt',
        legacyOutputKey: 'title',
        schemaId: 'title',
        adapter: 'scalar-replacement',
        mergePolicy: 'replace-authorized-target-only',
        contextPolicy: defaultContext,
    },
    summary: {
        field: 'summary',
        public: true,
        label: 'Synthèse',
        configType: 'enrich-dt',
        legacyOutputKey: 'summary',
        schemaId: 'summary',
        adapter: 'scalar-replacement',
        mergePolicy: 'replace-authorized-target-only',
        contextPolicy: defaultContext,
    },
    presentation: {
        field: 'presentation',
        public: false,
        label: 'Présentation',
        configType: null,
        legacyOutputKey: null,
        schemaId: null,
        adapter: null,
        mergePolicy: 'not-exposed',
        contextPolicy: defaultContext,
    },
    strengths: {
        field: 'strengths',
        public: true,
        label: 'Points forts',
        configType: 'enrich-dt',
        legacyOutputKey: 'strengths',
        schemaId: 'strengths',
        adapter: 'string-array-replacement',
        mergePolicy: 'replace-authorized-target-only',
        contextPolicy: defaultContext,
    },
    softSkills: {
        field: 'softSkills',
        public: true,
        label: 'Savoir-être',
        configType: 'enrich-dt',
        legacyOutputKey: 'softSkills',
        schemaId: 'softSkills',
        adapter: 'string-array-replacement',
        mergePolicy: 'replace-authorized-target-only',
        contextPolicy: defaultContext,
    },
    skills: {
        field: 'skills',
        public: true,
        label: 'Compétences',
        configType: 'enrich-dt-field-skills',
        legacyOutputKey: 'skills',
        schemaId: 'skills',
        adapter: 'referential-array-replacement',
        mergePolicy: 'replace-authorized-target-only',
        contextPolicy: defaultContext,
    },
    domains: {
        field: 'domains',
        public: true,
        label: 'Domaines',
        configType: 'enrich-dt-field-activityAreas',
        legacyOutputKey: 'activityAreas',
        schemaId: 'domains',
        adapter: 'referential-array-replacement',
        mergePolicy: 'replace-authorized-target-only',
        contextPolicy: defaultContext,
    },
    sectors: {
        field: 'sectors',
        public: true,
        label: 'Secteurs',
        configType: 'enrich-dt-field-expertiseAreas',
        legacyOutputKey: 'expertiseAreas',
        schemaId: 'sectors',
        adapter: 'referential-array-replacement',
        mergePolicy: 'replace-authorized-target-only',
        contextPolicy: defaultContext,
    },
    tools: {
        field: 'tools',
        public: true,
        label: 'Outils',
        configType: 'enrich-dt-field-tools',
        legacyOutputKey: 'tools',
        schemaId: 'tools',
        adapter: 'tool-array-replacement',
        mergePolicy: 'replace-authorized-target-only',
        contextPolicy: defaultContext,
    },
    experience: {
        field: 'experience',
        public: true,
        label: 'Expérience',
        configType: 'enrich-dt-field-experience',
        legacyOutputKey: 'experience',
        schemaId: 'experience',
        adapter: 'scalar-replacement',
        mergePolicy: 'replace-authorized-target-only',
        contextPolicy: { ...defaultContext, needRole: 'none' },
    },
    experiences: {
        field: 'experiences',
        public: true,
        label: 'Expériences',
        configType: 'enrich-dt-field-references-advanced',
        legacyOutputKey: 'references',
        schemaId: 'experiences',
        adapter: 'experience-array-replacement',
        mergePolicy: 'replace-authorized-target-only',
        contextPolicy: defaultContext,
    },
    education: {
        field: 'education',
        public: false,
        label: 'Études',
        configType: null,
        legacyOutputKey: null,
        schemaId: null,
        adapter: null,
        mergePolicy: 'not-exposed',
        contextPolicy: defaultContext,
    },
    training: {
        field: 'training',
        public: true,
        label: 'Formation',
        configType: 'enrich-dt-field-training',
        legacyOutputKey: 'training',
        schemaId: 'training',
        adapter: 'scalar-replacement',
        mergePolicy: 'replace-authorized-target-only',
        contextPolicy: defaultContext,
    },
    diplomas: {
        field: 'diplomas',
        public: true,
        label: 'Diplômes',
        configType: 'enrich-dt',
        legacyOutputKey: 'diplomas',
        schemaId: 'diplomas',
        adapter: 'qualification-array-replacement',
        mergePolicy: 'replace-authorized-target-only',
        contextPolicy: defaultContext,
    },
    certifications: {
        field: 'certifications',
        public: true,
        label: 'Certifications',
        configType: 'enrich-dt',
        legacyOutputKey: 'certifications',
        schemaId: 'certifications',
        adapter: 'qualification-array-replacement',
        mergePolicy: 'replace-authorized-target-only',
        contextPolicy: defaultContext,
    },
    languages: {
        field: 'languages',
        public: true,
        label: 'Langues',
        configType: 'enrich-dt-field-languages',
        legacyOutputKey: 'languages',
        schemaId: 'languages',
        adapter: 'language-array-replacement',
        mergePolicy: 'replace-authorized-target-only',
        contextPolicy: defaultContext,
    },
    experienceYears: {
        field: 'experienceYears',
        public: true,
        label: "Années d'expérience",
        configType: 'enrich-dt',
        legacyOutputKey: 'experience_years',
        schemaId: 'experienceYears',
        adapter: 'bounded-number-replacement',
        mergePolicy: 'replace-authorized-target-only',
        contextPolicy: defaultContext,
    },
    miscellaneous: {
        field: 'miscellaneous',
        public: true,
        label: 'Divers',
        configType: 'enrich-dt',
        legacyOutputKey: 'miscellaneous',
        schemaId: 'miscellaneous',
        adapter: 'scalar-replacement',
        mergePolicy: 'replace-authorized-target-only',
        contextPolicy: defaultContext,
    },
};
exports.RESOURCE_DT_TARGET_REGISTRY = Object.freeze(targetDefinitions);
const publicTargetSet = new Set(Object.values(exports.RESOURCE_DT_TARGET_REGISTRY)
    .filter((definition) => definition.public)
    .map((definition) => definition.field));
function isResourceDtTarget(value) {
    return publicTargetSet.has(value);
}
function assertResourceDtTargets(values) {
    const seen = new Set();
    for (const value of values) {
        if (!isResourceDtTarget(value))
            throw new RangeError(`Unsupported resource DT target: ${value}`);
        if (seen.has(value))
            throw new RangeError(`Duplicate resource DT target: ${value}`);
        seen.add(value);
    }
    if (!values.length)
        throw new RangeError('At least one resource DT target is required');
}
function getResourceDtTargetDefinition(target) {
    const definition = exports.RESOURCE_DT_TARGET_REGISTRY[target];
    if (!definition || !definition.public)
        throw new RangeError(`Unsupported resource DT target: ${target}`);
    return definition;
}
function getResourceDtTargetConfigType(target) {
    const configType = getResourceDtTargetDefinition(target).configType;
    if (!configType)
        throw new Error(`Resource DT target has no supported legacy config: ${target}`);
    (0, catalog_1.assertAiConfigType)(configType);
    return configType;
}
function getResourceDtTargetOutputSchema(target) {
    const schemaId = getResourceDtTargetDefinition(target).schemaId;
    if (!schemaId)
        throw new Error(`Resource DT target has no output schema: ${target}`);
    return (0, resource_dt_target_schemas_1.getResourceDtTargetSchema)(schemaId);
}
